import { AndBlockValues, EntityType } from './enroll-node.types';

export const getUsedEntityTypes = (watchedBlocks: AndBlockValues[] = []): EntityType[] => {
  return watchedBlocks
    .map((block) => block.entityType)
    .filter((type): type is EntityType => Boolean(type));
};
